import { NextSeo } from "next-seo";
import Link from "components/link";
export default function Acknowledgements() {
  return (
    <>
      <NextSeo
        title="Acknowledgements"
        description={
          "Credit where credit is due. These are some of the resources I used to build this site."
        }
      />
      <section
        id="acknowledgements"
        className="container flex flex-col items-center content-center justify-center space-x-8 md:flex-row"
      >
        <div className="mb-6 space-y-2 text-center md:mb-0 md:max-w-screen-sm">
          <h1 className="text-4xl">Acknowledgements</h1>
          <p className="text-2xl">
            Credit where credit is due! These are some of the resources I used
            to build this site.
          </p>
        </div>
        <div className="space-y-2 text-left">
          <div className="flex items-center content-center justify-start">
            <div className="min-w-max">Site built with&nbsp;</div>
            <Link
              href="https://nextjs.org/"
              rel="external nofollow"
              preload={false}
              title="Next.js"
            >
              <span className="font-extrabold">Next.js</span>
            </Link>
            &nbsp;by&nbsp;
            <Link
              href="https://vercel.com/"
              rel="external nofollow"
              preload={false}
              title="Vercel"
            >
              <span className="font-extrabold">Vercel</span>
            </Link>
            .
          </div>
          <div className="flex items-center content-center justify-start">
            <div className="min-w-max">Styled with&nbsp;</div>
            <Link
              href="https://tailwindcss.com/"
              rel="external nofollow"
              preload={false}
              title="Tailwind CSS"
            >
              <span className="font-extrabold">Tailwind CSS</span>
            </Link>
            .
          </div>
          <div className="flex items-center content-center justify-start">
            <div className="min-w-max">Icons made by&nbsp;</div>
            <Link
              href="https://www.freepik.com"
              rel="external nofollow"
              preload={false}
              title="Freepik"
            >
              <span className="font-extrabold">Freepik</span>
            </Link>
            &nbsp;from&nbsp;
            <Link
              href="https://www.flaticon.com/"
              rel="external nofollow"
              preload={false}
              title="Flaticon"
            >
              <span className="font-extrabold">Flaticon</span>
            </Link>
            .
          </div>
          <div className="flex items-center content-center justify-start">
            <div className="min-w-max">Hosted on&nbsp;</div>
            <Link
              href="https://pages.cloudflare.com/"
              rel="external nofollow"
              preload={false}
              title="Cloudflare Pages"
            >
              <span className="font-extrabold">Cloudflare Pages</span>
            </Link>
            .
          </div>
          <div className="flex items-center content-center justify-start">
            <div className="min-w-max">Version control hosted on&nbsp;</div>
            <Link
              href="https://github.com/"
              rel="external nofollow"
              preload={false}
              title="Github"
            >
              <span className="font-extrabold">Github</span>
            </Link>
            .
          </div>
        </div>
      </section>
    </>
  );
}
